import { TExperienceData } from "./Experience";

const ExperienceDesc = ({
  description,
}: Partial<Pick<TExperienceData, "description">>) => {
  return (
    <div className="flex flex-col gap-1 space-y-3 mt-4">
      {description?.map((desc, i) => (
        <p className="!mt-0 text-xs md:text-base" key={i}>
          {/* ❄️ {t(desc)} */}
          ❄️ {desc}
        </p>
      ))}
    </div>
  );
};

export default ExperienceDesc;
